module.exports = __webpack_public_path__ + "static/img/banner3.06a97c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/banner3.jpg
// module id = uORD
// module chunks = 0